"use client";

import { useState } from "react";

export default function ContactForm() {
  const [form, setForm] = useState({ nome: "", email: "", telefone: "", mensagem: "", unidade: "" });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="text-center py-20">
        <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-8"
          style={{ background: 'var(--sage-pale)' }}>
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" style={{ color: 'var(--forest)' }}>
            <polyline points="20 6 9 17 4 12"/>
          </svg>
        </div>
        <h3 className="font-serif mb-3" style={{ fontSize: '1.8rem', color: 'var(--forest)' }}>Mensagem enviada!</h3>
        <p style={{ color: 'var(--stone)' }}>Nossa equipe entrará em contato em breve.</p>
      </div>
    );
  }

  const inputClass = "w-full bg-transparent border-0 border-b-2 px-0 py-4 text-sm focus:outline-none focus:ring-0 transition-colors placeholder-stone-light";
  const inputStyle = { borderColor: 'rgba(232,226,214,0.8)', color: 'var(--charcoal)', height: '52px' };

  return (
    <form onSubmit={handleSubmit} className="space-y-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div>
          <label className="text-xs uppercase tracking-widest font-semibold block mb-3" style={{ color: 'var(--stone-light)' }}>
            Nome *
          </label>
          <input
            type="text"
            name="nome"
            value={form.nome}
            onChange={handleChange}
            required
            placeholder="Seu nome completo"
            className={inputClass}
            style={inputStyle}
          />
        </div>
        <div>
          <label className="text-xs uppercase tracking-widest font-semibold block mb-3" style={{ color: 'var(--stone-light)' }}>
            Email *
          </label>
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            required
            placeholder="seu@email.com"
            className={inputClass}
            style={inputStyle}
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div>
          <label className="text-xs uppercase tracking-widest font-semibold block mb-3" style={{ color: 'var(--stone-light)' }}>
            Telefone
          </label>
          <input
            type="tel"
            name="telefone"
            value={form.telefone}
            onChange={handleChange}
            placeholder="(51) 9 9999-9999"
            className={inputClass}
            style={inputStyle}
          />
        </div>
        <div>
          <label className="text-xs uppercase tracking-widest font-semibold block mb-3" style={{ color: 'var(--stone-light)' }}>
            Unidade de Interesse
          </label>
          <select
            name="unidade"
            value={form.unidade}
            onChange={handleChange}
            className={inputClass + " appearance-none cursor-pointer"}
            style={inputStyle}
          >
            <option value="">Selecione uma unidade</option>
            <option value="academia-code">Unidade Academia Code (Sarandi)</option>
            <option value="cristo-redentor">Unidade Cristo Redentor</option>
            <option value="jardim-leopoldina">Unidade Jardim Leopoldina</option>
          </select>
        </div>
      </div>

      <div>
        <label className="text-xs uppercase tracking-widest font-semibold block mb-3" style={{ color: 'var(--stone-light)' }}>
          Mensagem *
        </label>
        <textarea
          name="mensagem"
          value={form.mensagem}
          onChange={handleChange}
          required
          rows={5}
          placeholder="Como podemos ajudar você?"
          className="w-full bg-transparent border-0 border-b-2 px-0 py-4 text-sm focus:outline-none focus:ring-0 transition-colors placeholder-stone-light resize-none"
          style={{ borderColor: 'rgba(232,226,214,0.8)', color: 'var(--charcoal)' }}
        />
      </div>

      <button
        type="submit"
        className="btn-primary w-full justify-center py-5 text-sm"
      >
        Enviar Mensagem
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M22 2L11 13M22 2L15 22l-4-9-9-4 20-7z"/>
        </svg>
      </button>
    </form>
  );
}